/* currency */
const formatNumber = (n) =>
  n.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')

export const formatCurrency = (event) => {
  const {target, type} = event
  var {value} = target
  if (value === '') {
    return
  }
  var original_len = value.length
  var caret_pos = target.selectionStart
  if (value.indexOf('.') >= 0) {
    var decimal_pos = value.indexOf('.')
    var left_side = value.substring(0, decimal_pos)
    var right_side = value.substring(decimal_pos)

    left_side = formatNumber(left_side)
    right_side = formatNumber(right_side)
    if (type === 'blur') {
      right_side += '00'
    }
    right_side = right_side.substring(0, 2)
    value = '£' + left_side + '.' + right_side
  } else {
    value = formatNumber(value)
    value = '£' + value
    if (type === 'blur') {
      value += '.00'
    }
  }
  target.value = value
  var updated_len = value.length
  caret_pos = updated_len - original_len + caret_pos
  target.setSelectionRange(caret_pos, caret_pos)
}

export default {formatCurrency}
